export var isMobile = function () {
    var ua = navigator.userAgent.toLowerCase();
    var isMobileFrag = /iphone/.test(ua) || /android(.+)?mobile/.test(ua);
    return isMobileFrag;
};
